import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { useLanguage } from "../context/LanguageContext";

export const FAQ = () => {
  const { t } = useLanguage();
  
  return (
    <section
      id="faq"
      className="py-16 md:py-24 bg-[#FAFAF9]"
      data-testid="faq-section"
    >
      <div className="container mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-sm font-medium tracking-wide uppercase text-[#D4A373] mb-3 block">
            {t.faq.subtitle}
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold font-['Outfit'] tracking-tight text-[#0F172A]"
            data-testid="faq-title"
          >
            {t.faq.title}
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {t.faq.items.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white rounded-xl border border-[#e2e8f0] px-6 overflow-hidden"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left text-[#0F172A] font-semibold font-['Outfit'] hover:no-underline py-5 text-base md:text-lg">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#64748b] pb-5 leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
